import {
  formEncode,
  getToken,
  handleResponse,
  nextFormDataApi,
  nextJsonApi,
} from '@/API/core';
import axios from 'axios';
import { sortCompaniesByNumericId } from '@/lib/listOrdering';

const companies = {
  newCompany: async (data: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextFormDataApi.post(
        '/companies/new-company',
        formEncode(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  fetchCompanies: async () => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.get('/companies/fetch-companies', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (e) {
      response = e;
    }
    const result = handleResponse(response);
    return Array.isArray(result) ? sortCompaniesByNumericId(result) : result;
  },
  editComapany: async (data: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextFormDataApi.put(
        '/companies/edit-company',
        formEncode(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
};

export default companies;
